import { EmploymentPeriod } from './EmploymentPeriod';
import { Language } from './Language';
import { SkillSet } from './SkillSet';

export class Employee {
  static WorkingDaysInAWeek: number = 5;
  static DefaultWeeklyHours = 40;
  id: string;
  employmentPeriods: EmploymentPeriod[];
  employeeName: string;
  weeklyHours: number;
  skills: SkillSet;
  languages: Language[];
  location: string;
  startDate: Date;
  remote: boolean;
  seniority: string;
  role: string;
  certifications: string[];
  leads: string[];
  systemRole: string;
  photo: string;
  roles: string[];
  internal: boolean;
  external: boolean;
  score: number = 1;
  email: string;

  constructor({
    id = '',
    employeeName = '',
    employmentPeriods = [],
    skills = new SkillSet(),
    languages = [],
    certifications = [],
    location = '',
    remote = false,
    seniority = '',
    role = '',
    leads = [],
    roles = [],
    systemRole = '',
    photo = '',
    email = '',
  } = {}) {
    if (id === '') id = employeeName.replace(' ', '.').toLocaleLowerCase();
    this.id = id;
    this.employeeName = employeeName;
    if (employmentPeriods) {
      this.employmentPeriods = [];
      employmentPeriods.forEach((employmentPeriod: any) => {
        var period = new EmploymentPeriod(
          employmentPeriod.startDate,
          employmentPeriod.endDate,
          employmentPeriod.contractedHours
        );
        this.employmentPeriods.push(period);
      });
    } else {
      this.employmentPeriods = [];
    }
    //currently the data is taken from this field because the start date from ZEP is unreliable ex. Jenny Burger 12.11.2020 vs 31.01.2021 (which is correct)
    if (this.employmentPeriods.length > 0 && this.employmentPeriods[0].startDate)
      this.startDate = this.employmentPeriods[0].startDate;
    else this.startDate = new Date();

    this.weeklyHours = this.getWeeklyHours();

    if (skills && skills instanceof Array && !(skills instanceof SkillSet))
      skills = new SkillSet(skills);
    if (skills && skills.skills && skills.skills instanceof Array)
      skills = new SkillSet(skills.skills);
    this.skills = skills;
    this.languages = languages;
    this.location = location;

    if (this.location === 'Home Office') remote = true;
    this.remote = remote;
    this.seniority = seniority;
    this.role = role;
    this.certifications = certifications;
    this.leads = leads;
    if (leads) this.leads = leads.filter((lead) => lead);
    this.systemRole = systemRole;
    this.roles = roles;
    this.photo = photo;

    this.internal = seniority.startsWith('Intern');
    this.external = this.leads && this.leads.includes('Lead-EX');
    this.email = email;
  }

  /**
   * @param {Employee} employee
   * @param {number} numberOfWorkingDays
   */
  static calculateWorkingHoursInWeek(
    employee: Employee,
    numberOfWorkingDays: number,
    workingHoursInWeek = employee.weeklyHours
  ) {
    return Math.floor(workingHoursInWeek * (numberOfWorkingDays / 5));
  }

  getWeeklyHours() {
    if (!this.employmentPeriods || this.employmentPeriods.length === 0) return 40;

    const now = new Date();

    const currentEmploymentPeriod = this.employmentPeriods.find((period) =>
      this.isInEmploymentPeriod(period, now)
    );
    if (currentEmploymentPeriod) return currentEmploymentPeriod.contractedHours;

    const futureEmploymentPeriod = this.employmentPeriods.find(
      (period) => period.startDate && now <= period.startDate
    );
    if (futureEmploymentPeriod) return futureEmploymentPeriod.contractedHours;

    return this.employmentPeriods[0].contractedHours;
  }

  isInEmploymentPeriod(period: EmploymentPeriod, d: Date): boolean {
    return (
      period.startDate != null &&
      period.startDate <= d &&
      (period.endDate == null || d <= period.endDate)
    );
  }
}
